export const LOGIN_REQUEST = 'login/LOGIN_REQUEST'
export const LOGOUT_REQUEST = 'login/LOGOUT_REQUEST'
export const TOKEN_SET = 'login/TOKEN_SET'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/login/actionTypes.ts